// extracted by mini-css-extract-plugin
module.exports = {"all":"style_all__x3j5H","farBG":"style_farBG__1ql4E","bg":"style_bg__3h9FZ"};